import { useState } from "react";
import { TENANT_DOMAIN } from "../../utils/domain";
import axios from "axios";
import { ERROR_MESSAGES } from "../../constant/constant";
import { useTenantAuth } from "../../context/TeanantAuthProvider";
import { useNavigate } from "react-router-dom";

/**
 * Login data type
 * @typedef {Object} LoginData
 * @property {string} email - User's Email
 * @property {string} password - User's Password
 */

/**
 * @typedef {Object} TenantUser
 * @property {number} id
 * @property {string} tenant_id
 * @property {string} name
 * @property {string} email
 * @property {string} role
 */

/**
 * @typedef {Object} TenantToken
 * @property {string} access_token
 * @property {string} refresh_token
 * @property {number} access_token_expiry
 * @property {number} refresh_token_expiry
 */

/**
 * @typedef {Object} TenantInfo
 * @property {string} id
 * @property {string} name
 */

/**
 * @typedef {Object} TenantLoginData
 * @property {TenantUser} user
 * @property {TenantToken} token
 * @property {TenantInfo} tenant
 */

export const useTeanentLogin = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useTenantAuth();
  const navigate = useNavigate();

  /**
   * Logs in a user
   * @param {LoginData} loginData - The login data
   */

  const tenantLogin = async (loginData) => {
    setLoading(true);
    setError("");
    try {
      const data = await axios.post(
        `${TENANT_DOMAIN}/tenant/auth/login`,
        loginData,
      );

      /**
       * @type {TenantLoginData}
       */
      const responseData = data.data;
      const user = responseData?.data?.user;
      user.auth = responseData?.data.auth;
      login(user, responseData?.data?.token);
      navigate("/teacher/dashboard");
    } catch (err) {
      if (err.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(err?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, tenantLogin };
};
